<template>
  <main-request-form v-if="next" createForm :mandateData="formData" />
  <v-container v-else fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col class="pt-0" cols="12" md="12">
              <el-radio-group
                @change="changeInJournalType()"
                class="mt-0 mb-4"
                style="width: fit-content"
                label="in_journal_type"
                v-model="formData.in_journal_type"
                :items="inJournalTypes"
                required
              />
              <v-divider></v-divider>
            </v-col>
            <v-col v-if="showCode" class="pb-0" cols="12" md="3">
              <el-text-field
                required
                label="Identifikavimo kodas"
                v-model="formData.code"
                :maxlength="10"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters v-if="formData.in_journal_type">
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              :title="formData.in_journal_type == '421' ? 'Tęsti' : 'Ieškoti'"
              :loading="loading"
              @click.native="search()"
              color="primary"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import Enums from '@/enums'
import MainRequestForm from './MainRequestForm.vue'

export default {
  name: 'NewRequestForm',
  components: {MainRequestForm},
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {in_journal_type: ''},
      next: false
    }
  },
  computed: {
    showCode() {
      return this.formData.in_journal_type == "422" || this.formData.in_journal_type == "423"
    },
    inJournalTypes() {
      return [
        {
          label: this.$t(
            'Prokūrą išdavusio JA prašymas dėl prokūros įregistravimo'
          ),
          value: "421",
        },
        {
          label: this.$t(
            'Prokūrą išdavusio JA prašymas Įgaliojimų registrui dėl prokūros pabaigos'
          ),
          value: "422",
        },
        {
          label: this.$t(
            'Prokuristo prašymas Įgaliojimų registrui dėl prokūros pabaigos'
          ),
          value: "423",
        },
      ]
    },
    modeReadonly() {
      return false
    },
    getTitle() {
      return this.$t(`Naujas prašymas`)
    },
  },
  created() {},
  methods: {
    changeInJournalType() {
      let type = this.formData.in_journal_type
      this.formData = {}
      this.$set(this.formData, 'in_journal_type', type)
    },
    back() {
      this.$router.push({ name: 'adminRequestsPreparedSent' })
    },
    search() {
        this.$validator.validateAll().then((res) => {
          if (res) {
            if (this.formData.in_journal_type == "422" || this.formData.in_journal_type == "423") {
              this.loading = true
              this.pageloading = true
              let formData = this.formData
              let url = `mandates/byCode/${formData.code}/PP-ITPSP`
              this.$axios
                .get(url)
                .then((res) => {
                  const type = formData.in_journal_type
                  this.formData.in_journal_type = type
                  this.formData.mandate_id =  res.data.mandate.id
                  this.formData.mandate_kind =  res.data.mandate.mandate_kind
                  this.formData.mandate_code =  res.data.mandate.mandate_code
                  this.formData.status = '801'
                  this.next = true
                })
                .catch((err) => {
                  this.$root.$emit('DATA_ERROR', err)
                })
                .finally(() => {
                  this.loading = false
                  this.pageloading = false
                })
            } else {
              this.next = true
            }
          } else {
            this.$root.$emit('FORMAT_ERROR')
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
